import { Flex, Divider, Text, Image } from "@chakra-ui/react";
import { BsCheckCircle } from "react-icons/bs";
import colors from "core/resources/theme/colors";
import GraficoExecucaoOrcamentaria from "../../GraficoExecucaoOrcamentaria";
import { formatMoney } from "infra/helpers/number";
import calendar from "assets/images/svgs/calendar-clock.svg";

interface ContentPanelProps {
  loading?: boolean;
  previsto?: number;
  realizado?: number;
  saldo?: number;
}

export default function ContentPanel({
  loading,
  previsto,
  realizado,
  saldo,
}: ContentPanelProps) {
  return (
    <Flex
      gap={[10, 2]}
      alignItems="center"
      flexDir={{
        xmd: "row",
        sm: "column",
      }}
    >
      <Flex flexDir="column" align="center" gap={4}>
        <Text fontSize="16px" fontWeight="medium" w="200px" textAlign="center">
          Previsto X Realizado
        </Text>
        <GraficoExecucaoOrcamentaria
          loading={loading}
          previsto={previsto}
          realizado={realizado}
        />
      </Flex>
      <Flex flexDir="column" gap={4} w="100%" mt={10}>
        <Flex>
          <Flex align="center" gap={2} w="100%">
            <Flex
              w="30px"
              h="30px"
              bg={colors.blue100}
              rounded="full"
              align="center"
              justify="center"
            >
              <Image src={calendar} h="20px" w="auto" />
            </Flex>
            <Flex w="100%" justify="space-between">
              <Text>Previsto</Text>
              <Text fontWeight={"medium"}>
                {formatMoney(previsto ? previsto : 0)}
              </Text>
            </Flex>
          </Flex>
        </Flex>
        <Flex>
          <Flex align="center" gap={2} w="100%">
            <Flex
              w="30px"
              h="30px"
              bg={colors.orange50}
              rounded="full"
              align="center"
              justify="center"
            >
              <BsCheckCircle color={colors.orange} size={20} />
            </Flex>
            <Flex w="100%" justify="space-between">
              <Text>Realizado</Text>
              <Text fontWeight={"medium"}>
                {formatMoney(realizado ? realizado : 0)}
              </Text>
            </Flex>
          </Flex>
        </Flex>
        <Divider />
        <Flex w="100%" justify="space-between">
          <Text ml={9}>Diferença</Text>
          <Text fontWeight={"bold"}>
            {" "}
            {formatMoney(saldo ? Math.abs(saldo) : 0)}
          </Text>
        </Flex>
      </Flex>
    </Flex>
  );
}
